import { combineReducers } from "redux";

import devicesSlice from "./centreon/devicesSlice";

const centreonReducer = combineReducers({
	devices: devicesSlice,
	// hosts: hostsSlice,
	// pollers: pollersSlice,
});

export default centreonReducer;
